import { StoreTemplate } from "@/templates/TemplateLoader";
import { ReactNode } from "react";
import ContactElement from "@/templates/default/elements/Contact";
import SectionContent from "@/templates/default/elements/SectionContent";
import PageHeader from "@/templates/default/elements/PageHeader";

const elements = {
  ContactElement,
  SectionContent,
  PageHeader,
};

export function ContactPagesLoader(props: { children: ReactNode }) {
  StoreTemplate.load("farah-omar", "contact", elements);
  return props.children;
}
